var createEntitySelect, entityOptionTemplate, entityTableTemplate, jQuery, render, selectAttribute, selectTransformer, setupEvents, ui;

jQuery = require('jquery');

require('selectize');

ui = require('evesrp/common-ui');

entityTableTemplate = require('evesrp/templates/entity_table');

entityOptionTemplate = require('evesrp/templates/entity_option');

render = function(entities) {
  var $table, i, len, permission, ref, results, translationPromise;
  translationPromise = ui.setupTranslations();
  ref = ['submit', 'review', 'pay', 'audit', 'admin'];
  results = [];
  for (i = 0, len = ref.length; i < len; i++) {
    permission = ref[i];
    $table = (jQuery("#" + permission)).find('table');
    results.push(translationPromise.done(function() {
      var newTable;
      newTable = entityTableTemplate({
        entities: entities[permission],
        name: permission
      });
      return $table.replaceWith(newTable);
    }));
  }
  return results;
};

selectAttribute = function() {
  var $this, attr;
  $this = jQuery(this);
  attr = ($this.find('option:selected')).val();
  if (attr !== '') {
    ($this.find('options[values=""]')).remove();
  }
  jQuery.ajax({
    type: 'GET',
    url: window.location.pathname + "transformers/" + attr + "/",
    success: function(data) {
      var $option, $transformerSelect, choice, choices, i, len, results;
      $transformerSelect = jQuery('select#transformer');
      $transformerSelect.empty();
      choices = data[attr];
      $transformerSelect.prop('disabled', choices.length === 1);
      results = [];
      for (i = 0, len = choices.length; i < len; i++) {
        choice = choices[i];
        $option = jQuery('<option></option>');
        $option.append(choice[1]);
        $option.attr('value', choice[0]);
        if (choice[2] === true) {
          $option.prop('selected', true);
        }
        results.push($transformerSelect.append($option));
      }
      return results;
    }
  });
  return true;
};

selectTransformer = function() {
  var $form, $this;
  $this = jQuery(this);
  $form = $this.parents('form');
  jQuery.ajax({
    type: 'POST',
    url: window.location.pathname,
    data: $form.serialize()
  });
  return true;
};

createEntitySelect = function(selector) {
  var entitiesRequest, joinedPromise;
  entitiesRequest = jQuery.ajax({
    type: 'GET',
    url: scriptRoot + "/api/entities/"
  });
  joinedPromise = jQuery.when(entitiesRequest, ui.setupTranslations());
  return joinedPromise.done(function(entitiesResponse, translationResponse) {
    var data, type;
    data = entitiesResponse[0];
    return (jQuery(selector)).selectize({
      options: data.entities,
      openOnFocus: false,
      closeAfterSelect: true,
      dropdownParent: 'body',
      searchField: ['name'],
      valueField: 'id',
      labelField: 'name',
      optgroups: (function() {
        var i, len, ref, results;
        ref = ['User', 'Group'];
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          type = ref[i];
          results.push({
            value: type
          });
        }
        return results;
      })(),
      optgroupValueField: 'value',
      optgroupLabelField: 'value',
      optgroupField: 'type',
      onChange: function(entityID) {
        var $form, $id, selectize;
        selectize = this;
        $form = selectize.$input.closest('form');
        $id = $form.find('#id_');
        $id.val(entityID);
        return jQuery.ajax({
          type: 'POST',
          data: $form.serialize(),
          success: function(data) {
            selectize.clear(true);
            return $id.val('');
          },
          complete: function(jqxhr) {
            data = jqxhr.responseJSON;
            return render(data.entities);
          }
        });
      },
      render: {
        option: function(item, escape) {
          return entityOptionTemplate(item);
        },
        optgroup_header: function(data, escape) {
          var i18n_value;
          i18n_value = ui.i18n.gettext(data.value);
          return "<div class=\"optgroup-header\"> " + (escape(i18n_value)) + "s</div>";
        }
      }
    });
  });
};

setupEvents = function() {
  (jQuery('select#attribute')).change(selectAttribute);
  (jQuery('select#transformer')).change(selectTransformer);
  createEntitySelect('.entity-typeahead');
  return (jQuery('.permission')).submit(function(ev) {
    var $form;
    $form = jQuery(ev.target);
    jQuery.ajax({
      type: 'POST',
      url: window.location.pathname,
      data: $form.serialize(),
      complete: function(jqxhr) {
        var data;
        data = jqxhr.responseJSON;
        return render(data.entities);
      }
    });
    return false;
  });
};

exports.setupEvents = setupEvents;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
